import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";
import { SITE, NAV, waLink } from "../../lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-cypress text-cream relative overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pt-20 pb-10">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <p className="font-mono text-xs uppercase tracking-[0.28em] text-brass-light">Scrivimi</p>
          <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="mt-4 block font-serif text-2xl sm:text-4xl break-all hover:text-terra-light transition-colors">{SITE.email}</a>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href={waLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="inline-flex items-center gap-2 rounded-full border border-cream/30 px-5 py-2.5 text-sm hover:bg-cream hover:text-cypress transition-colors"><Phone className="w-4 h-4" /> WhatsApp {SITE.phone}</a>
            <a href={SITE.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-2 rounded-full border border-cream/30 px-5 py-2.5 text-sm hover:bg-cream hover:text-cypress transition-colors"><Instagram className="w-4 h-4" /> {SITE.igHandle}</a>
          </div>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.28em] text-brass-light">Pagine</p>
          <ul className="mt-4 space-y-2">
            {NAV.map((n) => (<li key={n.to}><Link to={n.to} data-testid={`footer-link-${n.id}`} className="text-cream/80 hover:text-cream">{n.label}</Link></li>))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.28em] text-brass-light">Negozio</p>
          <p className="mt-4 text-cream/80">{SITE.address}</p>
          <p className="mt-2 text-cream/80 whitespace-pre-line">{SITE.hours}</p>
          <a href={`mailto:${SITE.email}`} className="mt-2 inline-flex items-center gap-2 text-cream/80 hover:text-cream"><Mail className="w-4 h-4" /> Email</a>
        </div>
      </div>
      <div className="mt-20">
        <img src="/img/logo-cream.png" alt="Annette · Botanical · Home · Wedding & Event" className="w-full max-w-[880px] h-auto" />
      </div>
      <div className="mt-8 pt-6 border-t border-cream/15 flex flex-col sm:flex-row justify-between gap-3 text-xs text-cream/70">
        <span>© {new Date().getFullYear()} {SITE.full} · Puglia</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-cream">Area riservata</Link>
      </div>
    </div>
  </footer>
);
